import React, { useEffect, useState } from 'react'
import { StyleSheet, View, ScrollView, Text } from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import ContentEditable from 'react-contenteditable'
import Clipboard from '@react-native-clipboard/clipboard';
import { ToastContainer, toast } from 'react-toastify';
import DefaultButton from '../components/DefaultButton'
import Heading from '../components/Heading'
import Para from '../components/Para'
import LabeledTextField from '../components/LabeledTextField'
import VerticalSpace from '../components/VerticalSpace'
import NavigationBar from '../components/NavigationBar'
import FooterBar from '../components/FooterBar'
import Styles from '../constants/Styles'
import Colors from '../constants/Colors'
import Table from '../components/Table'
import Moment from 'moment';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import Api from '../components/Api'

import 'react-toastify/dist/ReactToastify.css';

interface ViewEventProps {
  navigation: any
  onContinue: Function
  selected_event: any
  gotopage: Function
  removeAttendee: Function
  attendees: any
  scenarios: any
  removeScenario: Function
  viewScenario: Function
  showScenarioResults: Function
  viewReviewPoint: Function
  toggleReviewPoint: Function
  EndEditing: Function
}


export default function ViewEvent ({ navigation, onContinue, selected_event, gotopage, attendees, removeAttendee, scenarios, removeScenario, viewScenario, showScenarioResults, viewReviewPoint, toggleReviewPoint, EndEditing }: ViewEventProps) {
	const [currentReviewPoint, SetCurrentReviewPoint] = useState(null)
	const [currentScenarioPoint, SetCurrentScenarioPoint] = useState(null)
	const [currentScenario, SetCurrentScenario] = useState(null)
	const [review_points, SetReviewPoints] = useState(null)
	var reviewPointChecker;
	
	const linkURL = "http://savagemacbeth.msg360.co.uk/?id="

	function handleAllocationNumberChange(attendee_id, newnumber) {
		new Api().UpdateEnrollmentAllocationNumber(attendee_id, newnumber)
  }

const copyToClipboard = (url) => {
    Clipboard.setString(url);
	showToast('Link copied')
  };
  
  const showToast = (msg) => {
	  window.scrollTo(0, 0);
	toast.success(msg, {
		  position: toast.POSITION.TOP_CENTER
		});
  };

  const attendee_columns = React.useMemo(
     () => [
       {
			Header: "First name",
			accessor: "enrolledUser.first_name",
			filterable: true
		},
		{
			Header: "Last name",
			accessor: "enrolledUser.last_name",
			filterable: true
		},
		{
			Header: "Email",
			accessor: "enrolledUser.email",
			filterable: true
		},
		{
			Header: "Allocation",
			accessor: "allocation_number",
			Cell: ( props ) => (
				  <div>
					<ContentEditable
							style={{padding: 5}}
						  html={props.row.original.allocation_number} // innerHTML of the editable div
						  disabled={false}       // use true to disable editing
						  onChange={(val) => handleAllocationNumberChange(props.row.original.id, val.target.value)} // handle innerHTML change
						  tagName='article' // Use a custom HTML tag (uses a div by default)
						/>
					</div>
				  )
		},
		{
			Header: "",
			accessor: "id",
Cell: ( props ) => (
	  <div>
		<a href="#" onClick={e => handleInviteAttendee(props.row.original.id)}>Invite</a>
		<span> | </span>
		<a href="#" onClick={e => copyToClipboard(linkURL + props.row.original.id)}>Copy to clipboard</a>
		<span> | </span>
		<a href="#" onClick={e => handleDeleteAttendee(props.row.original.id)}>Delete</a>
		</div>
      )
	  },
		{
			Header: "Invited",
			Cell: (props) => (
			  <div>
			  {props.row.original.dateInvited === null ? null : Moment(props.row.original.dateInvited).format("DD/MM/YYYY")}
				</div>
			)
		},
     ],
     []
   )

   const scenario_columns = React.useMemo(
     () => [
       {
			Header: "Name",
			accessor: "name",
			filterable: true,
			Cell: ( props ) => (
				  <div>
					<a href="#" onClick={e => doViewScenario(props.row.original)}>{props.row.original.name}</a>
				  </div>
			)
		},
		{
			Header: "",
			accessor: "id",
Cell: ( props ) => (
	  <div>
			  {props.row.original.release_results == "true" ? <a href="#" onClick={() => doShowScenarioResults(props.row.original.id, 'false')}>Hide report</a> : <a href="#" onClick={() => doShowScenarioResults(props.row.original.id, 'true')}>Show report</a>}
		<span> | </span>
		<a href="#" onClick={e => doRemoveScenario(props.row.original.id)}>Delete</a>
		</div>
      )
	  },
     ],
     []
   )

   const review_point_columns = React.useMemo(
     () => [
       {
			Header: "Name",
			accessor: "name",
			filterable: true,
			Cell: ( props ) => (
				  <div>
					<a href="#" onClick={e => toggleReviewPoint(props.row.original.id, 'true')}>{props.row.original.name}</a>
				  </div>
			)
		}
     ],
     []
   )

  const updateName = (text: string) => {
	  setName(text)
  }
  
  function handleDeleteAttendee(id) {
	  removeAttendee(id)
  }
  
  function doRemoveScenario(id) {
	  removeScenario(id)
  }
  
  	function doViewScenario(id) {
		viewScenario(id)
	}

  function doShowScenarioResults(id, show) {
	  showScenarioResults(id, show)
  }
  
  function handleInviteAttendee(id) {
	  new Api().InviteAttendee(id, onInviteAttendeeDone, onInviteAttendeeFailed)
  }
  
  const toggleEdit = () => {
	  EndEditing()
  }

  function handleInviteAllAttendees(event_id) {
		confirmAlert({
		  title: 'Confirm invite all',
		  message: 'Are you sure you want to do this.',
		  buttons: [
			{
			  label: 'Yes',
			  onClick: () => new Api().InviteAllAttendees(event_id, onInviteAttendeeDone, onInviteAttendeeFailed)
			},
			{
			  label: 'No'
			}
		  ]
		});
  }
  
	function onGetCurrentReviewPointBasedOnEventDone(current_review_point){
		if (current_review_point != null)
		{
			console.log(current_review_point)
			SetCurrentReviewPoint(current_review_point)
			new Api().getScenarioPoint(current_review_point.scenario_point_id, onGetScenarioPointDone)
		}
		else
		{
			SetShowPage(true)
		}
	}

	function onGetScenarioPointDone(scenario_point){
		SetCurrentScenarioPoint(scenario_point)
		new Api().getScenario(scenario_point.scenario_id, onGetScenarioDone)
	}

	function onGetScenarioDone(scenario){
		SetCurrentScenario(scenario)
		new Api().ListAllEventReviewPoints(selected_event.id, onGetEventReviewPointsDone)
	}
	
	function onGetEventReviewPointsDone(event_review_points){
		console.log(event_review_points)
		SetReviewPoints(event_review_points)
		
		SetShowPage(true)
	}
	
	const handleGoToCurrentReviewPoint = (review_point) => {
		viewReviewPoint(review_point)
	}

  const onInviteAttendeeDone = () => {
	showToast('Email sent')
  }
  
  const onInviteAttendeeFailed = () => {
		toast.error('There was a problem sending the email', {
		  position: toast.POSITION.TOP_CENTER
		});
	}

	function handleChangeName(scenario_id, newname) {
		selected_event.name = newname;
		new Api().UpdateEventName(scenario_id, newname)
  }
  
  return (
  <View>
	<KeyboardAwareScrollView style={styles.outerContainer}>
	  <View style={styles.innerContainer}>
		<NavigationBar navigation={navigation}></NavigationBar>
	  </View>
	  <View style={styles.container, styles.greenStripe}>
		<View style={[styles.innerContainer, styles.container]}>
			<Heading fontsize={44} >Programme: 	
				<ContentEditable
							innerRef={selected_event}
						  html={selected_event.name} // innerHTML of the editable div
						  disabled={false}       // use true to disable editing
						  onChange={(val) => handleChangeName(selected_event.id, val.target.value)} // handle innerHTML change
						  tagName='article' // Use a custom HTML tag (uses a div by default)
						/>			
			</Heading>
			<div style={{color: '#000000', width: '100%'}}><a href='#' onClick={() => gotopage('welcome')}>Home</a> -> <a href='#' onClick={() => gotopage('listevents')}>List Programmes</a> -> View Programme</div>
			<VerticalSpace height={10} />
		</View>
	  </View>
      <View style={styles.container}>
			<View style={[styles.innerContainer, styles.container]}>
				<VerticalSpace height={20} />
				<DefaultButton onPress={() => gotopage('addattendee')} text={'Add Attendee'} />
				<VerticalSpace height={20} />
				<Text style={styles.sectionHeader}>Attendees</Text>
				<VerticalSpace height={20} />
				<DefaultButton onPress={e => handleInviteAllAttendees(selected_event.id)} text="Invite all attendees"/>
				<VerticalSpace height={20} />
				<ToastContainer />
				<Table data={attendees} columns={attendee_columns} hideSearch={true} />
				
				<VerticalSpace height={20} />
				<DefaultButton onPress={() => gotopage('addscenario')} text={'Add Scenario'} />
				<VerticalSpace height={20} />
				<Text style={styles.sectionHeader}>Scenarios</Text>
				<VerticalSpace height={20} />
				<Table data={scenarios} columns={scenario_columns} hideSearch={true} />
				<VerticalSpace height={20} />
				{(currentReviewPoint != null) ? <View><Text style={styles.sectionHeader}>Switch to</Text>
				<VerticalSpace height={20} />
				<Table data={review_points} columns={review_point_columns} hideSearch={true} />
				<VerticalSpace height={20} /></View> : null}
				<DefaultButton onPress={toggleEdit} text="End editing"/>
				<VerticalSpace height={40} />
				<DefaultButton onPress={onContinue} text="Return"/>
				<VerticalSpace height={20} />
		</View>
      </View>
	  <FooterBar />
    </KeyboardAwareScrollView>
  </View>
  )
}


const styles = StyleSheet.create({
  container: {
    paddingHorizontal: Styles.standardPadding,
  },
  ScrollViewDriver: {
	  display: 'table',
		width: '100%'
  },
  tableData11: {
	  display: 'table-cell',
	  width: 50,
	  padding: 10
  },
  table: {
	  display: 'table-row'
  },
  tableData1: {
	  display: 'table-cell',
	  width: 70,
	  padding: 10
  },
  tableData1S: {
	  color: 'blue',
	  display: 'table-cell',
	  width: 70,
	  padding: 10
  },
  greenStripe: {
	  backgroundColor: Colors.green,
	  color: '#ffffff',
  },
  violetStripe: {
	  backgroundColor: Colors.violet,
	  color: '#ffffff',
  },
  innerContainer: {
	maxWidth: 1000,
    alignSelf: 'center',
    width: '100%',
  },
  outerContainer: {
    alignSelf: 'center',
    width: '100%',
	fontFamily: "NoeDisplayMedium",
  },
  imageWrapper: {
	  textAlign: 'center',
	  justifyContent: 'center',
    alignItems: 'center'
  },
  waitingimgstyle: {
	maxWidth: '200px'
  },
  linkstyle: {
	  color: '#0000ff'
  },
  sectionHeader: {
	  fontWeight: 'bold'
  },  
})
